module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"sort":"Sortierung","title":"Bezeichnung"},"en":{"sort":"Sort","title":"Title"}}')
  delete Component.options._Ctor
}
